<section>
  <ng-container *ngIf="isLoading; else loadedTemplate">
    <app-loading [onlyIcon]="true"></app-loading>
  </ng-container>
  <ng-template #loadedTemplate>
    <div class="commercial-portfolio">
      <h2 class="commercial-portfolio-title">{{ 'COMMERCIAL_PORTFOLIO.TITLE' | i18nextEager }}</h2>
      <img class="commercial-portfolio-goTo" src="/assets/icons/arrow.svg" alt="Arrow" (click)="handleNavigate()" />
      <app-table
        class="commercial-portfolio-table"
        *ngIf="data"
        [data]="carteraList"
        [colsTable]="colsTable"
        (clickButton)="handleButton($event)"
      ></app-table>
    </div>
  </ng-template>
</section>
